import React from 'react';
import NextLink from 'next/link';
import { MARKET_PAGES, MarketPage } from './market-pages';

const TABS = [
  { key: 'diamond', label: 'Kim cương', detail: 'Giá tham khảo quốc tế', icon: 'diamond' },
  { key: 'gold', label: 'Giá vàng', detail: 'Thị trường trong nước', icon: 'gold' },
  { key: 'forex', label: 'Ngoại tệ', detail: 'Ngoại tệ / VND', icon: 'usd' },
] as const;

const TabIcon = ({ type }: { type: string }) => (
  <svg viewBox="0 0 32 32" fill="none" stroke="currentColor" strokeWidth="1.5" className="tw-h-7 tw-w-7 tw-shrink-0" aria-hidden="true">
    {type === 'gold' ? <><path d="M7 18h18l4 9H3l4-9ZM11 5h10l4 9H7l4-9Z" /><path d="m11 5 3 9m7-9-3 9M7 18l4 9m14-9-4 9" /></> : type === 'usd' ? <><circle cx="16" cy="16" r="12" /><path d="M21 11c-2-4-11-3-10 2 1 4 10 2 10 7 0 5-9 5-11 1m6-15v20" /></> : <><path d="m3 12 7-8h12l7 8-13 16L3 12Z" /><path d="M3 12h26M10 4l-1 8 7 16 7-16-1-8m-12 0 6 8 6-8" /></>}
  </svg>
);

export const PriceTabs = ({ active }: { active: MarketPage }) => (
  <div className="tw-mx-auto tw-w-full tw-max-w-[1296px] tw-px-5 md:tw-px-8 tw-mb-5 md:tw-mb-7">
    <nav aria-label="Các bảng giá" className="tw-grid tw-grid-cols-3 tw-border tw-border-jr-line tw-rounded-lg tw-overflow-hidden tw-bg-white">
      {TABS.map((tab) => <NextLink key={tab.key} href={MARKET_PAGES[tab.key].path} scroll={false} prefetch={false}>
        <a aria-current={active === tab.key ? 'page' : undefined} className={`tw-relative tw-flex tw-flex-col sm:tw-flex-row tw-items-center tw-justify-center sm:tw-justify-start tw-gap-2 sm:tw-gap-4 tw-px-2 sm:tw-px-6 tw-py-4 tw-transition-colors focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-[-4px] focus-visible:tw-outline-jr-gold ${active === tab.key ? 'tw-bg-jr-green tw-text-white' : 'tw-bg-white tw-text-jr-green hover:tw-bg-[#F2F5F0]'}`}>
          <span className="tw-hidden sm:tw-block"><TabIcon type={tab.icon} /></span>
          <span className="tw-min-w-0 tw-text-center sm:tw-text-left"><span className="tw-block tw-text-[13px] sm:tw-text-[16px] tw-font-medium">{tab.label}</span><span className={`tw-hidden md:tw-block tw-mt-1 tw-text-[12px] ${active === tab.key ? 'tw-text-white/75' : 'tw-text-jr-mute'}`}>{tab.detail}</span></span>
          {active === tab.key && <span className="tw-absolute tw-bottom-0 tw-inset-x-4 tw-h-[3px] tw-bg-[#D9BF7C]" />}
        </a>
      </NextLink>)}
    </nav>
  </div>
);
